import api from './api'

export const contactusAPI = {
  // Submit contact us form
  submit: (contactData) => {
    return api.post('/contactus/submit', contactData)
  }
}
